export const PenProtectionPlanSourceTypes = {
  USER: 'user',
  PROVIDER: 'provider',
};
